import styled from 'styled-components';

export const PageWrapper = styled.div`
    width: 100%;
    min-height: 80vh;
    max-width: 1000px;
    margin: 0 auto;
    padding: 30px 20px 60px;

    @media (max-width: 768px) {
        padding: 20px 16px 40px;
    }
`;

export const BackButton = styled.button`
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.75);
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;

    &:hover {
        background: rgba(255, 153, 0, 0.1);
        border-color: rgba(255, 153, 0, 0.4);
        color: var(--white-color);
    }

    &:focus-visible {
        outline: 2px solid var(--primary-color);
        outline-offset: 2px;
    }
`;

export const PageHeader = styled.div`
    text-align: center;
    max-width: 720px;
    margin: 30px auto 24px;

    @media (max-width: 768px) {
        margin: 20px auto 16px;
    }
`;

export const PageTitle = styled.h1`
    color: var(--white-color);
    font-size: 2rem;
    font-weight: 800;
    line-height: 1.2;
    margin: 0 0 12px 0;
    text-wrap: balance;

    @media (max-width: 768px) {
        font-size: 1.5rem;
    }
`;

export const PageSubtitle = styled.p`
    color: rgba(255, 255, 255, 0.65);
    font-size: 1.05rem;
    line-height: 1.5;
    margin: 0;

    @media (max-width: 768px) {
        font-size: 0.95rem;
    }
`;

export const RetentionBanner = styled.div`
    background: ${props => props.subtle
        ? 'rgba(255, 255, 255, 0.04)'
        : 'rgba(255, 153, 0, 0.08)'};
    border: 1px solid ${props => props.subtle
        ? 'rgba(255, 255, 255, 0.12)'
        : 'rgba(255, 153, 0, 0.25)'};
    border-radius: 12px;
    color: rgba(255, 255, 255, 0.85);
    padding: 14px 18px;
    margin: 0 auto 14px;
    max-width: 720px;
    font-size: 0.95rem;
    text-align: center;
    line-height: 1.5;

    strong {
        color: ${props => props.subtle
            ? 'rgba(255, 255, 255, 0.95)'
            : 'var(--primary-color)'};
    }

    & + & {
        margin-top: 0;
    }
`;

export const CharactersGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin: 0 auto;
    max-width: 720px;
`;

export const CharacterCard = styled.div`
    background: linear-gradient(145deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));
    border: 1.5px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    opacity: ${props => props.dim ? 0.55 : 1};
    transition: border-color 0.2s ease;

    &:hover {
        border-color: rgba(255, 153, 0, 0.4);
    }

    @media (max-width: 600px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 14px;
    }
`;

export const CardLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    flex: 1;
    min-width: 0;
`;

export const CharacterImage = styled.img`
    width: 64px;
    height: 64px;
    border-radius: 12px;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
    background: rgba(0, 0, 0, 0.2);
    border: 1.5px solid rgba(255, 153, 0, 0.4);
    flex-shrink: 0;
`;

export const CardInfo = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
`;

export const CharacterName = styled.h2`
    color: var(--white-color);
    font-size: 1.15rem;
    font-weight: 700;
    margin: 0 0 4px 0;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;

export const ModePill = styled.span`
    display: inline-block;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.3px;
    padding: 2px 8px;
    border-radius: 10px;
    /* Bate-papo (chat): laranja translúcido | Praticar (learn): roxo translúcido */
    background: ${props => props.mode === 'chat'
        ? 'rgba(255, 153, 0, 0.18)'
        : 'rgba(155, 109, 230, 0.18)'};
    color: ${props => props.mode === 'chat'
        ? 'rgb(255, 184, 79)'
        : 'rgb(190, 155, 240)'};
    border: 1px solid ${props => props.mode === 'chat'
        ? 'rgba(255, 153, 0, 0.4)'
        : 'rgba(155, 109, 230, 0.4)'};
    white-space: nowrap;
`;

export const CharacterStats = styled.p`
    color: rgba(255, 255, 255, 0.55);
    font-size: 0.88rem;
    margin: 0;
`;

export const CardActions = styled.div`
    display: flex;
    gap: 8px;
    flex-shrink: 0;

    @media (max-width: 600px) {
        width: 100%;
        justify-content: flex-end;
    }
`;

export const ActionButton = styled.button`
    background: ${props => props.danger ? 'rgba(220, 53, 69, 0.12)' : 'rgba(255, 153, 0, 0.15)'};
    color: ${props => props.danger ? 'rgb(255, 130, 140)' : 'var(--primary-color)'};
    border: 1px solid ${props => props.danger ? 'rgba(220, 53, 69, 0.35)' : 'rgba(255, 153, 0, 0.4)'};
    padding: 8px 14px;
    border-radius: 10px;
    font-size: 0.88rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;

    &:hover {
        background: ${props => props.danger ? 'rgba(220, 53, 69, 0.22)' : 'rgba(255, 153, 0, 0.28)'};
        border-color: ${props => props.danger ? 'rgba(220, 53, 69, 0.6)' : 'rgba(255, 153, 0, 0.7)'};
    }

    &:focus-visible {
        outline: 2px solid ${props => props.danger ? 'rgb(220, 53, 69)' : 'var(--primary-color)'};
        outline-offset: 2px;
    }
`;

export const EmptyState = styled.div`
    background: linear-gradient(145deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));
    border: 1.5px dashed rgba(255, 255, 255, 0.15);
    border-radius: 20px;
    padding: 60px 30px;
    text-align: center;
    max-width: 600px;
    margin: 0 auto;
`;

export const EmptyIcon = styled.div`
    font-size: 4rem;
    margin-bottom: 16px;
    opacity: 0.55;
`;

export const EmptyTitle = styled.h2`
    color: var(--white-color);
    font-size: 1.4rem;
    font-weight: 700;
    margin: 0 0 10px 0;
`;

export const EmptyText = styled.p`
    color: rgba(255, 255, 255, 0.6);
    font-size: 1rem;
    margin: 0;
    line-height: 1.5;
`;

export const FooterActions = styled.div`
    margin: 36px auto 0;
    max-width: 720px;
    display: flex;
    justify-content: center;
`;

export const DangerButton = styled.button`
    background: transparent;
    color: rgb(255, 130, 140);
    border: 1px solid rgba(220, 53, 69, 0.45);
    padding: 12px 22px;
    border-radius: 30px;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;

    &:hover {
        background: rgba(220, 53, 69, 0.15);
        border-color: rgba(220, 53, 69, 0.75);
    }

    &:focus-visible {
        outline: 2px solid rgb(220, 53, 69);
        outline-offset: 2px;
    }
`;

/* Modal de confirmação */
export const ConfirmOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 20px;
`;

export const ConfirmDialog = styled.div`
    background: rgb(28, 28, 30);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    padding: 28px;
    max-width: 460px;
    width: 100%;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
`;

export const ConfirmTitle = styled.h3`
    color: var(--white-color);
    font-size: 1.3rem;
    font-weight: 700;
    margin: 0 0 14px 0;
    line-height: 1.3;
`;

export const ConfirmText = styled.p`
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.98rem;
    line-height: 1.55;
    margin: 0 0 24px 0;
`;

export const ConfirmButtons = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    flex-wrap: wrap;
`;

export const ConfirmButton = styled.button`
    background: ${props => props.danger ? 'rgba(220, 53, 69, 0.2)' : 'transparent'};
    color: ${props => props.danger ? 'rgb(255, 130, 140)' : 'rgba(255, 255, 255, 0.8)'};
    border: 1px solid ${props => props.danger ? 'rgba(220, 53, 69, 0.5)' : 'rgba(255, 255, 255, 0.2)'};
    padding: 10px 18px;
    border-radius: 10px;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;

    &:hover {
        background: ${props => props.danger ? 'rgba(220, 53, 69, 0.3)' : 'rgba(255, 255, 255, 0.06)'};
        border-color: ${props => props.danger ? 'rgba(220, 53, 69, 0.8)' : 'rgba(255, 255, 255, 0.35)'};
    }

    &:focus-visible {
        outline: 2px solid ${props => props.danger ? 'rgb(220, 53, 69)' : 'var(--primary-color)'};
        outline-offset: 2px;
    }
`;
